<section
  class="flex h-full w-full flex-col overflow-hidden bg-white"
  role="dialog"
  [attr.aria-label]="'board_v3_export_title' | translate"
>
  <header class="flex items-start gap-3 border-b border-gray-100 px-5 py-4">
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-lg font-bold text-gray-900">{{ 'board_v3_export_title' | translate }}</h2>
      <p class="m-0 mt-1 text-sm text-gray-500">{{ 'board_v3_export_hint' | translate }}</p>
    </div>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-5 py-4">
    <div class="mb-5">
      <label class="mb-2 block text-sm font-medium text-gray-700">{{ 'board_v3_export_format' | translate }}</label>
      <div class="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-1">
        @for (option of formats; track option) {
          <button
            type="button"
            class="rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
            [class.bg-white]="format === option"
            [class.shadow-sm]="format === option"
            [class.text-gray-900]="format === option"
            [class.text-gray-500]="format !== option"
            [disabled]="isExporting"
            (click)="format = option"
          >
            {{ option }}
          </button>
        }
      </div>
    </div>

    <div class="mb-1 flex items-center justify-between">
      <div class="text-sm font-semibold text-gray-800">{{ 'board_v3_export_fields' | translate }}</div>
      <div class="flex items-center gap-2 text-xs text-gray-400">
        <span>{{ selectedCount }}/{{ fields.length }}</span>
        <button
          type="button"
          class="font-medium text-blue-600 hover:underline"
          [disabled]="isExporting"
          (click)="toggleAll(selectedCount < fields.length)"
        >
          {{ (selectedCount < fields.length ? 'board_v3_export_select_all' : 'board_v3_export_clear_all') | translate }}
        </button>
      </div>
    </div>

    @if (standardFields.length) {
      <div class="mb-1.5 mt-3 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_import_standard_fields' | translate }}
      </div>
      <div class="flex flex-col gap-1.5">
        @for (field of standardFields; track fieldKey(field)) {
          <div class="flex w-full min-w-0 items-center gap-2 rounded-lg border border-gray-100 bg-white px-3 py-2">
            <app-icon class="shrink-0 text-gray-400">{{ field.icon || 'tune' }}</app-icon>
            <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ field.name }}</span>
            <p-toggleswitch [ngModel]="isSelected(field)" [disabled]="isExporting" (ngModelChange)="toggleField(field, $event)" />
          </div>
        }
      </div>
    }

    @if (customFields.length) {
      <div class="mb-1.5 mt-4 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_import_custom_fields' | translate }}
      </div>
      <div class="flex flex-col gap-1.5">
        @for (field of customFields; track fieldKey(field)) {
          <div class="flex w-full min-w-0 items-center gap-2 rounded-lg border border-gray-100 bg-white px-3 py-2">
            <app-icon class="shrink-0 text-gray-400">{{ field.icon || 'tune' }}</app-icon>
            <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ field.name }}</span>
            <p-toggleswitch [ngModel]="isSelected(field)" [disabled]="isExporting" (ngModelChange)="toggleField(field, $event)" />
          </div>
        }
      </div>
    }

    @if (!fields.length) {
      <p class="m-0 rounded-xl bg-gray-50 p-4 text-sm text-gray-500">{{ 'board_v3_no_fields_to_display' | translate }}</p>
    }
  </div>

  <footer class="flex items-center justify-between gap-3 border-t border-gray-100 px-5 py-4">
    <app-button [btnType]="'stroked'" [disabled]="isExporting" (onChangeClick)="onCancel()">{{ 'cancel' | translate }}</app-button>
    <app-button [disabled]="!selectedCount || isExporting" (onChangeClick)="onExport()">
      <span class="flex items-center gap-1"><app-icon>download</app-icon>{{ 'board_v3_settings_export_csv' | translate }}</span>
    </app-button>
  </footer>
</section>
